<template>
  <PageShell :title="$t('interface.title.funding')">
    <FundingGrid :products="fundings" />
  </PageShell>
</template>

<script>
import FundingGrid from './components/FundingGrid.vue'; 
import PageShell from './components/PageShell.vue';
import { resolveDataUrl } from './utils/dataResolver';

export default {
  components: {
    FundingGrid,
    PageShell
  },
  data() {
    return {
      fundings: [] // 存储融资信息数据
    };
  },
  async mounted() {
    await this.initializeData();
  },
  methods: {
    async initializeData() {
      try {
        const response = await fetch(resolveDataUrl('data/funding.json')); 
        if (!response.ok) {
          throw new Error('Failed to load funding.json');
        }
        this.fundings = await response.json();
      } catch (error) {
        console.error('加载 funding.json 时出错:', error);
      }
    },
  }
};
</script>

<style scoped>
/* 页面级样式已全部收敛到 PageShell / SiteTitle / cards.css，此处无需额外规则 */
</style>
